import { PropsWithChildren, useState } from "react";
import { createStore } from "zustand";

import { ActivityCompareStoreType } from "./activity_compare_store.types";
import { ActivityCompareStoreContext } from "./activity_compare_store_context";

export const ActivityCompareStoreProvider = ({ children }: PropsWithChildren) => {
  const [store] = useState(
    createStore<ActivityCompareStoreType>()((set, get) => ({
      compareIds: {},
      actions: {
        setCompareIds: (compareIds) => set({ compareIds }),
        clearComparisonToast: () => set({ compareIds: {} }),
        addProfileToComparison: (profileId) => {
          const currentCompareIds = get().compareIds;
          set({ compareIds: { ...currentCompareIds, [profileId]: true as const } });
        },
        removeProfileFromComparison: (profileId) => {
          const currentCompareIds = { ...get().compareIds };
          delete currentCompareIds[profileId];
          set({ compareIds: currentCompareIds });
        }
      }
    }))
  );

  return (
    <ActivityCompareStoreContext.Provider value={store}>{children}</ActivityCompareStoreContext.Provider>
  );
};
